import { render } from "./FooterbakerSection.vue?vue&type=template&id=c1deaf00&scoped=true"
import script from "./FooterbakerSection.vue?vue&type=script&lang=js"
export * from "./FooterbakerSection.vue?vue&type=script&lang=js"

import "./FooterbakerSection.vue?vue&type=style&index=0&id=c1deaf00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1deaf00"]])

export default __exports__